import script from "./AlignLeftIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AlignLeftIcon.vue?vue&type=script&setup=true&lang=js"

export default script